import { render, staticRenderFns } from "./ThreadDetails.vue?vue&type=template&id=7103e6ee"
import script from "./ThreadDetails.vue?vue&type=script&lang=js"
export * from "./ThreadDetails.vue?vue&type=script&lang=js"
import style0 from "./ThreadDetails.vue?vue&type=style&index=0&id=7103e6ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports